module.exports = __webpack_public_path__ + "static/media/kp.a8ad547e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kp.svg
// module id = 2133
// module chunks = 0